import { useCallback, useState } from 'react';

const STORAGE_KEY = 'nav.collapsed';

/**
 * Collapsed/expanded state for the sidebar rail, remembered across sessions.
 *
 * Defaults to expanded: a first-time visitor should see the labels. Only an explicit
 * collapse is stored, matching how a nav group remembers its own expanded state.
 */
export function useSidebarCollapsed() {
  const [collapsed, setCollapsed] = useState<boolean>(() => {
    try {
      return localStorage.getItem(STORAGE_KEY) === 'true';
    } catch {
      // Blocked storage is a preference we cannot remember, never a reason to fail.
      return false;
    }
  });

  const toggle = useCallback(() => {
    setCollapsed((current) => {
      const next = !current;

      try {
        localStorage.setItem(STORAGE_KEY, String(next));
      } catch {
        // Remembering the state is a convenience, never a requirement.
      }

      return next;
    });
  }, []);

  return { collapsed, toggle };
}
